// XXX: dummy change to triger `devenv:stash:frontend`
import 'app/common/publicPath';
import 'app/common/patch';

import 'app/legacy/app';
import 'app/interop';

import 'app/app.scss';

import { get } from 'lodash';

import { configureTracking } from '@zapier/toolbox-tracking';
import { configureErrorTracking } from '@zapier/toolbox-redux-framework';

import buildPlugins from 'app/common/buildPlugins';

import z from 'app/common/z';

import Devtools from 'app/devtools-loader';

import createApp from 'app/common/createApp';

import {
  firstInputDelayObserver,
  largestContentfulPaintObserver,
  cumulativeLayoutShiftObserver,
  sendEventToDatadog,
} from '@zapier/performance-monitoring';

firstInputDelayObserver(fid => {
  sendEventToDatadog('first-input-delay', { firstInputDelay: fid });
});

largestContentfulPaintObserver(lcp => {
  sendEventToDatadog('largest-contentful-paint', {
    largestContentfulPaint: lcp,
  });
});

cumulativeLayoutShiftObserver(cls => {
  sendEventToDatadog('cumulative-layout-shift', {
    cumulativeLayoutShift: cls,
  });
});

configureErrorTracking();

configureTracking({
  service: 'web',
  release: process.env.COMMIT_HASH,
});

Devtools.preCreateApp();

const initialReduxState = JSON.parse(
  get(window, ['INITIAL_REACT_REDUX_STATE'], '{}')
);
const app = createApp({ plugins: buildPlugins(), initialReduxState });

z.app.dangerousGlobalStore = app.store;

Devtools.postCreateApp(app);

// Append the commit version, provided by webpack
window.Z_COMMIT_HASH = process.env.COMMIT_HASH;

app.run();
